export default "__VITE_ASSET__s0CuakZK__"